import type { RuleConstructorParameters } from './ts/rule-constructor-parameter.type'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ValidationFn = (value: any) => Promise<boolean | string> | boolean | string

export type ValidationRuleConfig = {
  type: string
}

export type ValidationRuleConstructor<P extends RuleConstructorParameters> = (
  params: P
) => ValidationFn

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const validationRuleConstructorMap: Map<string, ValidationRuleConstructor<any>> = new Map()

export function defineRule<P extends RuleConstructorParameters>(
  key: string,
  constructor: ValidationRuleConstructor<P>
): ValidationRuleConstructor<P> {
  validationRuleConstructorMap.set(key, constructor)
  return validationRuleConstructorMap.get(key)!
}
